import { Button } from '@utilitywarehouse/hearth-react';
import { FC } from 'react';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';

interface EndAppointmentDialogProps {
  end: () => void;
  cancel?: () => void;
}

interface EndAppointmentDialogUIProps {
  dialogId: DialogID;
  onCancel: () => void;
  onEnd: () => void;
}

const EndAppointmentDialogUI = ({
  dialogId,
  onCancel,
  onEnd,
}: EndAppointmentDialogUIProps) => (
  <Dialog
    id={dialogId}
    heading="Are you sure you'd like to end the appointment?"
    preventDismiss
    hideCloseButton
  >
    <DialogActions ignoreControl>
      <Button variant="outline" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="solid" colorScheme="destructive" onClick={onEnd}>
        End appointment
      </Button>
    </DialogActions>
  </Dialog>
);

const EndAppointmentDialog: FC<EndAppointmentDialogProps> = ({
  end,
  cancel,
}) => {
  const dialog = useDialog(DialogID.APMT_END);

  const handleCancel = () => {
    if (cancel) {
      cancel();
    }
    dialog.setOpen(false);
  };

  const handleEnd = () => {
    end();
    dialog.setOpen(false);
  };

  return (
    <EndAppointmentDialogUI
      dialogId={dialog.id}
      onCancel={handleCancel}
      onEnd={handleEnd}
    />
  );
};

export type { EndAppointmentDialogProps, EndAppointmentDialogUIProps };

export { EndAppointmentDialog, EndAppointmentDialogUI };
